import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { get, isEmpty } from 'lodash';
import ChartDownloadButton from './ChartDownloadButton';
import Model from './Model';
import { FiInfo } from 'react-icons/fi';
import LineChartBody from './LineChartBody';

const LineChartComponent = ({ data }) => {
  const Chartdata = data;
  const chartRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedLegend, setSelectedLegend] = useState(null);
  const [desc, setDesc] = useState('');

  // Extract chart data from the input prop
  const extractChartData = () => {
    const chartValues = Object.values(get(Chartdata, 'data', {}));
    const xAxis = get(Chartdata, 'series', []);
    const series = Object.keys(get(Chartdata, 'data', {}));
    const unit = Chartdata?.unit || '';

    return {
      data: chartValues,
      xAxis: xAxis,
      Series: series,
      unit: unit
    };
  };

  const Data = extractChartData();

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Handle legend selection from chart
  const handleLegendSelect = legend => {
    // Guard against undefined/null legend
    if (!legend) return;

    setSelectedLegend(legend);

    // Update description based on selected legend
    if (Chartdata?.info && typeof Chartdata.info === 'object') {
      setDesc(Chartdata.info[legend] || '');
    } else {
      setDesc('');
    }
  };

  // Reset description when data changes
  useEffect(() => {
    setDesc('');
    setSelectedLegend(null);
  }, [data]);

  return (
    <Card className="h-100 overflow-hidden">
      <FalconCardHeader
        title={Chartdata?.label}
        titleTag="h5"
        light={true}
        desc={Chartdata?.desc}
        endEl={
          <ChartDownloadButton
            chartData={Data.data}
            xAxis={Data.xAxis}
            series={Data.Series}
            filename={`${Chartdata?.label || 'chart'}`}
          />
        }
        infoBtn={
          !isEmpty(Chartdata?.description) && (
            <FiInfo onClick={handleShowModal} />
          )
        }
      />
      <Card.Body className="h-100 px-3" dir="ltr">
        <LineChartBody
          chartRef={chartRef}
          chartdata={Data}
          label={Chartdata?.label}
          onLegendSelect={handleLegendSelect}
        />
      </Card.Body>
      <Card.Footer className="bg-white py-2 card-footer-style">
        {desc ? (
          <h5 className="infrence-info">
            {selectedLegend}: {desc}
          </h5>
        ) : (
          <></>
        )}
      </Card.Footer>
      <Model
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        description={Chartdata?.description}
        title={Chartdata?.label}
      />
    </Card>
  );
};

LineChartComponent.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.object,
    series: PropTypes.array,
    info: PropTypes.object,
    label: PropTypes.string,
    unit: PropTypes.string,
    description: PropTypes.object
  })
};

export default LineChartComponent;
